import React from 'react';
import './index.css';
import { FormattedMessage } from 'react-intl';

export function Biography() {
  return (
    <div className="biography">
      <div className="biography-icon">
        <img src="./img/icon_1x.png" />
      </div>
      <div className="biography-content">
        <FormattedMessage id="WhiteMatrix" />
      </div>
    </div>
  );
}
